module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 04 Farma Pasa - Landram (gost Eli Maca).13a2c71e.mp3";